const getProfileList = state => state.profileList;
const getEditProfileData = state => state.editProfileData;
const getViewProfileData = state => state.viewProfileData;
const getprofileId = state => state.profileId;
const loading = state => state.loading;

export default {
  getProfileList,
  getEditProfileData,
  getViewProfileData,
  getprofileId,
  loading
};
